import { render, staticRenderFns } from "./Clan.vue?vue&type=template&id=0d84ea86&"
import script from "./Clan.vue?vue&type=script&lang=js&"
export * from "./Clan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports